/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';

import { IAddress } from '@bytel/checkout';

import { MarkerIcon } from '@base/common/models/bytel-gmaps.interface';

import { BasicObject } from '@interfaces/checkout.interface';
import { CheckoutStore } from '@interfaces/store.interface';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export abstract class DeliveryBaseService {
    protected readonly WEEK_DAYS: BasicObject = {
        1: 'Lundi',
        2: 'Mardi',
        3: 'Mercredi',
        4: 'Jeudi',
        5: 'Vendredi',
        6: 'Samedi',
        7: 'Dimanche',
    };

    public abstract readonly DELIVERY_TYPE: string;

    public deleteSelectedStore(): void {
        // This empty method is intentional
    }

    public improveLabelDisplay(label?: string, productInformation = ''): string {
        if (!label) {
            return '';
        }
        return (
            (label[0].toUpperCase() + label.slice(1).toLowerCase()).replace('la poste', 'La Poste') +
            ' ' +
            productInformation
        );
    }

    protected calculateDistanceFromLocation(distance: string): number {
        const dist: number = +(+distance / 1000).toString().substring(0, 3);
        return dist === 0 ? +distance / 100 : dist;
    }

    protected extractStreetAndNumber(address: string): { street: string; street_number: string } {
        const street_number: string = address.split(' ')[0].trim();
        const street: string = address.replace(street_number, '').replace(',', '').trim();

        return {
            street,
            street_number,
        };
    }

    protected generateMarkerIcon(iconName: string, size: google.maps.Size): MarkerIcon {
        return {
            url: `assets/checkout/${iconName}.svg`,
            size,
            scaledSize: size,
            iconName,
        };
    }
    public abstract getStores(address: IAddress): Observable<CheckoutStore[]>;
}
